import React from 'react';
import { Plugins } from '@leverege/plugin';
const RsrcModelEditorFactory = Plugins.createFactory('RsrcModelEditor', {
  pluginKey: 'editor',
  strategy: Plugins.reactStrategy(React, 'value')
});
export default RsrcModelEditorFactory;